<template>
    <div class="icon">
        <svg
            class="h-full w-full"
            fill="currentColor"
            viewBox="0 0 512 512"
            stroke="currentColor"
        >
            <path
                d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
                stroke-width="3"
            />
        </svg>
    </div>
</template>

<script>
/**
 * icon-線條箭頭向下
 */
export default {
    name: 'IconChevronDown'
};
</script>

<style scoped>

</style>
